import { Slider } from "./Slider";

/**
 * @en A VSlider control allows the user to select a value by moving the slider thumb between the endpoints of the slider track. The VSlider control is oriented vertically. The slider track extends from bottom to top, and the label is positioned on the left and right sides of the track.
 * @zh 使用 VSlider 控件，用户可以通过在滑块轨道的终点之间移动滑块来选择值。VSlider 控件采用垂直方向。滑块轨道从下往上扩展，而标签位于轨道的左右两侧。
 */

export class VSlider extends Slider {

}